
// Import additions
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Box, Button, Typography, TextField, Select, MenuItem,
  FormControl, InputLabel, Paper, Grid, Table, TableHead,
  TableRow, TableCell, TableBody, Divider
} from '@mui/material';

// Utility function for date comparison
const isWithinDateRange = (date, type) => {
  const now = new Date();
  const inputDate = new Date(date);
  if (type === 'recently') return (now - inputDate) / (1000 * 60 * 60 * 24) <= 7;
  if (type === 'this_month') return inputDate.getMonth() === now.getMonth() && inputDate.getFullYear() === now.getFullYear();
  if (type === 'last_month') {
    const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    return inputDate.getMonth() === lastMonth.getMonth() && inputDate.getFullYear() === lastMonth.getFullYear();
  }
  return true;
};

const OldFeesCollection = () => {
  const [view, setView] = useState('');
  const [students, setStudents] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [paymentData, setPaymentData] = useState({ amount: '', transaction_type: 'cash' });
  const [form, setForm] = useState({ name: '', class: '', fees: '' });
  const [historyData, setHistoryData] = useState([]);
  const [filter, setFilter] = useState('recently');

  useEffect(() => {
    fetchStudents();
    fetchHistory();
  }, []);

  const fetchStudents = async () => {
    const res = await axios.get('http://feemanagementsystem.oxfordconventschoolkhajuri.com/backend/api/get_old_students.php');
    setStudents(res.data);
  };

  const fetchHistory = async () => {
    const res = await axios.get('http://feemanagementsystem.oxfordconventschoolkhajuri.com/backend/api/get_old_fee_history.php');
    setHistoryData(res.data);
  };

  const addStudent = async () => {
    await axios.post('http://feemanagementsystem.oxfordconventschoolkhajuri.com/backend/api/add_old_student.php', form);
    alert("Student Added!");
    setForm({ name: '', class: '', fees: '' });
    fetchStudents();
  };

  const handlePayment = async () => {
    const payload = {
      student_id: selectedStudent.id,
      amount: paymentData.amount,
      transaction_type: paymentData.transaction_type
    };

    const res = await axios.post('http://feemanagementsystem.oxfordconventschoolkhajuri.com/backend/api/pay_old_fee.php', payload);
    const paymentId = res.data.payment_id;

    printTuitionBill({ student: selectedStudent, amount: paymentData.amount, billNumber: paymentId });

    fetchStudents();
    fetchHistory();
    setSelectedStudent(null);
    setPaymentData({ amount: '', transaction_type: 'cash' });
  };
 const printTuitionBill = ({ student, amount, billNumber }) => {
    const today = (() => {
      const d = new Date();
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    })();

    const content = `
      <style>
        body { font-family: Arial; font-size: 12px; margin: 0; }
        .print-button { display: block; margin: 10px auto; padding: 5px 15px; font-size: 14px; cursor: pointer; }
        @media print { .print-button { display: none; } }
        .page { display: flex; justify-content: space-between; gap: 20px; padding: 15mm; box-sizing: border-box; }
        .bill { width: 48%; border: 1px solid #000; padding: 15px; box-sizing: border-box; }
        .bill-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
        .bill-header img { width: 50px; height: 50px; object-fit: contain; }
        .bill-title { flex: 1; text-align: center; font-size: 14px; font-weight: bold; line-height: 1.4; }
        .bill-sub-header { text-align: center; font-size: 11px; margin-bottom: 12px; }
        .row { display: flex; justify-content: space-between; margin-bottom: 5px; }
        .table { width: 100%; margin-top: 10px; border-collapse: collapse; }
        .table th, .table td { border: 1px solid #000; padding: 6px 8px; text-align: left; }
        .sign { text-align: right; margin-top: 25px; font-size: 11px; }
      </style>

      <button class="print-button" onclick="window.print()">Print</button>
      <div class="page">
        ${[1, 2].map(() => `
          <div class="bill">
            <div class="bill-header">
              <img src="${window.location.origin}/school-logo.jpg" alt="Logo" />
              <div class="bill-title">OXFORD CONVENT<br>ENGLISH MEDIUM SCHOOL, KHAJURI</div>
            </div>
            <div class="bill-sub-header">
              KHAJURI - 585 314 - Tq. Aland Dist. Kalaburagi<br>
              <strong>TUITION FEE RECEIPT</strong><br>
              <div><strong>FEE Bill No: ${billNumber}</strong></div>
            </div>
            <div class="row"><div>Name: ${student.name}</div><div>Date: ${today}</div></div>
            <div class="row"><div>Class: ${student.class}</div><div>Total Fees: ₹${student.fees}</div></div>
            <div class="row"><div>Paid This Time: ₹${amount}</div><div>Due: ₹${student.fees - student.paid - amount}</div></div>
            <table class="table">
              <tr><th>Particulars</th><th>Amount</th></tr>
              <tr><td>Tuition Fee Paid</td><td>₹${amount}</td></tr>
            </table>
            <div class="sign">Sign of Cashier/H.M</div>
          </div>
        `).join('')}
      </div>
    `;

    const win = window.open('', '', 'height=800,width=1200');
    win.document.write('<html><head><title>Tuition Fee Bill</title></head><body>');
    win.document.write(content);
    win.document.write('</body></html>');
    win.document.close();

    win.onload = () => {
      const images = win.document.images;
      let loadedCount = 0;
      if (images.length === 0) {
        win.print();
        return;
      }
      for (let img of images) {
        img.onload = img.onerror = () => {
          loadedCount++;
          if (loadedCount === images.length) {
            win.print();
          }
        };
      }
    };
  };

  const printHistory = () => {
    const table = document.getElementById('history-table');
    const newWindow = window.open('', '', 'width=1000,height=800');
    const html = `
      <html><head><title>History</title>
      <style>
        body { font-family: Arial; font-size: 13px; padding: 20px; }
        table { width: 100%; border-collapse: collapse; margin-top: 20px; }
        th, td { border: 1px solid #000; padding: 8px; text-align: left; }
        th { background-color: #f5f5f5; }
        h2 { text-align: center; }
        .total { margin-top: 20px; font-weight: bold; text-align: right; }
      </style>
      </head><body>
      <h2>Old Fee Collection History</h2>
      ${table.outerHTML}
      <div class="total">Total Collected: ₹${filteredHistory.reduce((acc, item) => acc + parseFloat(item.amount_paid), 0)}</div>
      </body></html>
    `;
    newWindow.document.write(html);
    newWindow.document.close();
    newWindow.focus();
    newWindow.print();
  };

  const filteredStudents = students.filter(s => s.class === selectedClass);
  const filteredHistory = historyData.filter(entry => isWithinDateRange(entry.date, filter));

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', p: 3 }}>
      <Typography variant="h4" align="center" gutterBottom>Old Fees Collection</Typography>

      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 3 }}>
        <Button variant="contained" color="success" onClick={() => setView('add')}>Add Student</Button>
        <Button variant="contained" color="success" onClick={() => setView('pay')}>Pay Fees</Button>
        <Button variant="contained" color="info" onClick={() => setView('history')}>History</Button>
      </Box>

      {view === 'add' && (
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>Add Student</Typography>
          <TextField label="Name" fullWidth margin="normal" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
          <FormControl fullWidth margin="normal">
            <InputLabel>Class</InputLabel>
            <Select value={form.class} label="Class" onChange={e => setForm({ ...form, class: e.target.value })}>
              {['Nursery', 'LKG', 'UKG', '1', '2', '3', '4', '5', '6', '7', '8'].map(cls => (
                <MenuItem key={cls} value={cls}>{cls}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField label="Fees" fullWidth margin="normal" value={form.fees} onChange={e => setForm({ ...form, fees: e.target.value })} />
          <Button variant="contained" onClick={addStudent}>Submit</Button>
        </Paper>
      )}

      {view === 'pay' && (
  <Paper sx={{ p: 3 }}>
    <Typography variant="h6" gutterBottom>Pay Student Fees</Typography>

    {/* Select Class */}
    <FormControl fullWidth margin="normal">
      <InputLabel>Select Class</InputLabel>
      <Select
        value={selectedClass}
        label="Select Class"
        onChange={(e) => {
          setSelectedClass(e.target.value);
          setSelectedStudent(null); // Reset student if class changes
        }}
      >
        {[...new Set(students.map(s => String(s.class)))].map(cls => (
          <MenuItem key={cls} value={cls}>{cls}</MenuItem>
        ))}
      </Select>
    </FormControl>

    {/* Select Student */}
    {selectedClass && (
      <FormControl fullWidth margin="normal">
        <InputLabel>Select Student</InputLabel>
        <Select
          value={selectedStudent ? String(selectedStudent.id) : ''}
          label="Select Student"
          onChange={(e) => {
            const student = students.find(s => String(s.id) === e.target.value);
            setSelectedStudent(student || null);
          }}
        >
          {students
            .filter(s => String(s.class) === String(selectedClass))
            .map(s => (
              <MenuItem key={s.id} value={String(s.id)}>
                {s.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    )}

    {/* Payment Form */}
    {selectedStudent && (
      <Box sx={{ backgroundColor: '#f0f4f8', p: 2, mt: 2 }}>
        <Typography><b>Name:</b> {selectedStudent.name}</Typography>
        <Typography><b>Class:</b> {selectedStudent.class}</Typography>
        <Typography><b>Total Fees:</b> ₹{selectedStudent.fees}</Typography>
        <Typography><b>Paid:</b> ₹{selectedStudent.paid}</Typography>
        <Typography><b>Due:</b> ₹{selectedStudent.fees - selectedStudent.paid}</Typography>
        <TextField
          label="Pay Amount"
          fullWidth
          margin="normal"
          value={paymentData.amount}
          onChange={e => setPaymentData({ ...paymentData, amount: e.target.value })}
        />
        <FormControl fullWidth margin="normal">
          <InputLabel>Transaction Type</InputLabel>
          <Select
            value={paymentData.transaction_type}
            onChange={e => setPaymentData({ ...paymentData, transaction_type: e.target.value })}
          >
            <MenuItem value="cash">Cash</MenuItem>
            <MenuItem value="upi">UPI</MenuItem>
          </Select>
        </FormControl>
        <Button variant="contained" onClick={handlePayment}>Submit</Button>
      </Box>
    )}
  </Paper>
)}


      {view === 'history' && (
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>Fee Collection History</Typography>

          <FormControl fullWidth margin="normal">
            <InputLabel>Filter</InputLabel>
            <Select value={filter} onChange={e => setFilter(e.target.value)}>
              <MenuItem value="recently">Recently (7 days)</MenuItem>
              <MenuItem value="this_month">This Month</MenuItem>
              <MenuItem value="last_month">Last Month</MenuItem>
              <MenuItem value="all">All</MenuItem>
            </Select>
          </FormControl>

          <Button variant="outlined" onClick={printHistory} sx={{ mt: 1, mb: 2 }}>Print</Button>

          <Table id="history-table">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Class</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredHistory.map((entry, index) => (
                <TableRow key={index}>
                  <TableCell>{entry.name}</TableCell>
                  <TableCell>{entry.class}</TableCell>
                  <TableCell>₹{entry.amount_paid}</TableCell>
                  <TableCell>{entry.transaction_type}</TableCell>
                  <TableCell>{entry.date}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <Divider sx={{ my: 2 }} />
          <Typography align="right" sx={{ fontWeight: 'bold' }}>
            Total Collected: ₹{filteredHistory.reduce((acc, item) => acc + parseFloat(item.amount_paid), 0)}
          </Typography>
        </Paper>
      )}
    </Box>
  );
};

export default OldFeesCollection;
